import DefaultLayout from '../../layouts/DefaultLayout';
import apiClient from '../../services/api/apiClient';
import { useAuth } from '../../utils/context/AuthContext';
import { IClient } from '../../utils/types/IClient';
import ChangePasswordModal from '../../components/modals/wizard/user/ChangePasswordModal';
import { Helmet } from 'react-helmet-async';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import QueryErrorAlerts, { QueryErrorEntry } from '../../components/others/QueryErrorAlerts';

const MyAccountPage = () => {
    const { user } = useAuth();

    // ---

    const {
        data: client = null,
        refetch: refetchClient,
        isError: isClientError,
        error: clientError,
    } = useQuery<IClient | null>({
        queryKey: ['userClient'],
        queryFn: async () => {
            const res = await apiClient.get('/api/clients/getUserClient');
            return res.data ?? null;
        },
        meta: { title: 'Chargement du client' },
        enabled: user?.roles?.includes('Client') ?? false,
        staleTime: 0
    });

    // ---

    const queryErrors = useMemo<QueryErrorEntry[]>(() => [{ isError: isClientError, error: clientError, title: 'Erreur lors du chargement du client', refetch: refetchClient }], [isClientError, clientError, refetchClient]);

    // ---

    return (
        <>
            <Helmet>
                <title>Profil :: Portail PETROSIL</title>
            </Helmet>

            <div className="page-header d-print-none">
                <div className="container-xl">
                    <div className="row g-2 align-items-center">
                        <div className="col">
                            <h2 className="page-title">Paramètres du compte</h2>
                        </div>
                    </div>
                </div>
            </div>

            <div className="page-body">
                <div className="container-xl">
                    <QueryErrorAlerts queries={queryErrors} />

                    <div className="card">
                        <div className="row g-0">
                            <div className="col-12 col-md-3 border-end">
                                <div className="card-body">
                                    <div className="list-group list-group-transparent">
                                        <a href="/profil" className="list-group-item list-group-item-action d-flex align-items-center active">
                                            Mon compte
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-9 d-flex flex-column">
                                <div className="card-body">
                                    <h2 className="mb-4">Mon compte</h2>

                                    <h3 className="card-title mt-4">Profil</h3>
                                    <div className="row g-3">
                                        <div className="col-md">
                                            <div className="form-label">Nom d'utilisateur</div>
                                            <input type="text" className="form-control" readOnly value={user?.login} />
                                        </div>
                                        <div className="col-md">
                                            <div className="form-label">Adresse e-mail</div>
                                            <input type="text" className="form-control" readOnly value={user?.email} />
                                        </div>

                                        {user?.roles?.includes('Client') === false && (
                                            <div className="col-md">
                                                <div className="form-label">Rôle(s) utilisateur</div>
                                                <input type="text" className="form-control" readOnly value={user?.roles?.join(', ') ?? ''} />
                                            </div>
                                        )}
                                    </div>

                                    {user?.roles?.includes('Client') && (
                                        <>
                                            <div className="hr-text">#</div>

                                            <div className="col-md">
                                                <div className="form-label">Client</div>
                                                <input type="text" className="form-control" readOnly value={client?.cardName ?? '-'} />
                                            </div>
                                        </>
                                    )}

                                    <div className="hr-text">#</div>

                                    <h3 className="card-title mt-4">Mot de passe</h3>
                                    <div>
                                        <ChangePasswordModal />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

MyAccountPage.Layout = DefaultLayout;

export default MyAccountPage;
